import { useEffect } from "react";
import * as ActionsTypes from "../../../../../../common/state/StatesConstants";

const initialState = {
  error: null,
  isLoading: false,
  compteDeResultatBilans: [],
  compteDeResultatBilan: {},
};

const compteDeResultatBilansReducer = (state = initialState, action) => {
  switch (action.type) {
    // ##-----------GET_COMPTE_DE_RESULTAT_BILANS-----------##
    case ActionsTypes.GET_COMPTE_DE_RESULTAT_BILANS:
      return {
        ...state,
        isLoading: true,
        error: null,
        compteDeResultatBilans: [],
      };
    case ActionsTypes.GET_COMPTE_DE_RESULTAT_BILANS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        compteDeResultatBilans: action.response.data.data,
      };
    case ActionsTypes.GET_COMPTE_DE_RESULTAT_BILANS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        compteDeResultatBilans: [],
      };
    // ##-----------END_GET_COMPTE_DE_RESULTAT_BILANS-----------##

    // ##-----------ADD_COMPTE_DE_RESULTAT_BILAN-----------##
    case ActionsTypes.ADD_COMPTE_DE_RESULTAT_BILAN:
      return {
        ...state,
        isLoading: true,
        error: null,
        //compteDeResultatBilans: [...state.compteDeResultatBilans],
      };

    case ActionsTypes.ADD_COMPTE_DE_RESULTAT_BILAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        //compteDeResultatBilans: [...state.compteDeResultatBilans, action.response.data.data],
      };

    case ActionsTypes.ADD_COMPTE_DE_RESULTAT_BILAN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        //compteDeResultatBilans: [...state.compteDeResultatBilans],
      };
    // ##-----------END_ADD_COMPTE_DE_RESULTAT_BILAN-----------##

    // ##-----------EDIT_COMPTE_DE_RESULTAT_BILAN-----------##
    case ActionsTypes.EDIT_COMPTE_DE_RESULTAT_BILAN:
      return {
        ...state,
        isLoading: true,
        error: null,
        compteDeResultatBilan: {},
      };

    case ActionsTypes.EDIT_COMPTE_DE_RESULTAT_BILAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        compteDeResultatBilan: action.response.data.data,
      };

    case ActionsTypes.EDIT_COMPTE_DE_RESULTAT_BILAN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        compteDeResultatBilan: {},
      };
    // ##-----------END_EDIT_COMPTE_DE_RESULTAT_BILAN-----------##

    // ##-----------UPDATE_COMPTE_DE_RESULTAT_BILAN-----------##
    case ActionsTypes.UPDATE_COMPTE_DE_RESULTAT_BILAN:
      return {
        ...state,
        isLoading: true,
        error: null,
        //compteDeResultatBilans: [...state.compteDeResultatBilans],
      };

    case ActionsTypes.UPDATE_COMPTE_DE_RESULTAT_BILAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        // compteDeResultatBilans: [
        //   action.response.data.data,
        //   ...state.compteDeResultatBilans.filter(
        //     (compteDeResultatBilan) => compteDeResultatBilan.id != action.response.data.data.id
        //   ),
        // ],
      };

    case ActionsTypes.UPDATE_COMPTE_DE_RESULTAT_BILAN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        //compteDeResultatBilans: [...state.compteDeResultatBilans],
      };
      // ##-----------END_UPDATE_COMPTE_DE_RESULTAT_BILAN-----------##
  
      case ActionsTypes.DELETE_COMPTE_DE_RESULTAT_BILAN:
        return {
          ...state,
          isLoading: true,
          error: null,
          //compteDeResultatBilans: [...state.compteDeResultatBilans],
        };
  
      case ActionsTypes.DELETE_COMPTE_DE_RESULTAT_BILAN_SUCCESS:
        return {
          ...state,
          isLoading: false,
          error: null,
          // compteDeResultatBilans: [
          //   ...state.compteDeResultatBilans.filter(
          //     (compteDeResultatBilan) => compteDeResultatBilan.id != action.response.data.data
          //   ),
          // ],
        };
  
      case ActionsTypes.DELETE_COMPTE_DE_RESULTAT_BILAN_FAIL:
        return {
          ...state,
          isLoading: false,
          error: action.error,
          //compteDeResultatBilans: [...state.compteDeResultatBilans],
        };
      // ##-----------END_DELETE_COMPTE_DE_RESULTAT_BILAN-----------##
    // ##-----------END_UPDATE_COMPTE_DE_RESULTAT_BILAN-----------##

    case ActionsTypes.UPLOAD_COMPTE_DE_RESULTAT_BILAN:
      return {
        ...state,
        isLoading: true,
        error: null,
        //compteDeResultatBilans: [...state.compteDeResultatBilans],
      };

    case ActionsTypes.UPLOAD_COMPTE_DE_RESULTAT_BILAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        // compteDeResultatBilans: [
        //   ...state.compteDeResultatBilans.filter(
        //     (compteDeResultatBilan) => compteDeResultatBilan.id != action.response.data.data
        //   ),
        // ],
      };

    case ActionsTypes.UPLOAD_COMPTE_DE_RESULTAT_BILAN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        //compteDeResultatBilans: [...state.compteDeResultatBilans],
      };
    // ##-----------END_UPLOAD_COMPTE_DE_RESULTAT_BILAN-----------##

    default:
      return state;
  }
};

export default compteDeResultatBilansReducer;
